const trimTrailingSlash = (value = "") => value.replace(/\/+$/, "");

export const API_BASE_URL = trimTrailingSlash(
  process.env.REACT_APP_API_URL || "http://localhost:5000"
);

const buildUrl = (path) => `${API_BASE_URL}${path}`;

const parseJson = async (response) => {
  const text = await response.text();
  try {
    return text ? JSON.parse(text) : {};
  } catch {
    return {};
  }
};

const getErrorMessage = (payload, fallback) => {
  return payload?.message || fallback;
};

export async function apiRequest(path, options = {}) {
  const url = buildUrl(path);

  let response;

  try {
    response = await fetch(url, {
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...(options.headers || {})
      }
    });
  } catch {
    throw new Error(`Unable to connect to server (${url})`);
  }

  const payload = await parseJson(response);

  if (!response.ok) {
    throw new Error(getErrorMessage(payload, `Request failed ${response.status}`));
  }

  return payload;
}

export async function apiRequestWithToken(path, token, options = {}) {
  return apiRequest(path, {
    ...options,
    headers: {
      Authorization: `Bearer ${token}`,
      ...(options.headers || {})
    }
  });
}

export async function apiRequestFormWithToken(path, token, body) {
  const url = buildUrl(path);

  let response;

  try {
    response = await fetch(url, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`
      },
      body
    });
  } catch {
    throw new Error(`Unable to connect to server (${url})`);
  }

  const payload = await parseJson(response);

  if (!response.ok) {
    throw new Error(getErrorMessage(payload, `Request failed ${response.status}`));
  }

  return payload;
}